<template>
  <v-app>
    <!-- sidebar-drawer -->
    <v-navigation-drawer v-model="sidebar" app>
      <v-list>
        <v-list-tile
         v-for="item in menuItems"
         :key="item.title"
         :to="item.path"
         @click="sidebar = !sidebar"
         >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar color="" app>
      <span class="hidden-sm-and-up">
        <v-toolbar-side-icon color="" @click="sidebar = !sidebar"></v-toolbar-side-icon>
      </span>
      <v-toolbar-title class="font-weight-light">
        {{ appTitle }}
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer
      height="auto"
      color="primary white--text"
      class="text-xs-center mt-3"
    >
      <v-layout justify-center row wrap>
        <v-flex xs12 class="text-xs-center hidden-sm-and-down" mt-5>
          <img v-bind:src="require('../assets/textchecker-logo-v1.png')" d-flex>
        </v-flex>

        <v-flex xs12 class="text-xs-center hidden-md-and-up" mt-5>
          <img v-bind:src="require('../assets/sp-textchecker-logo.png')" d-flex>
        </v-flex>

        <v-divider></v-divider>

        <v-flex xs12 justify-space-around mt-2>
          <v-btn
            v-for="link in links"
            :key="link.id"
            :to="link.route"
            color="white"
            flat
            round
          >
            {{ link.label }}
          </v-btn>
        </v-flex>

        <v-divider></v-divider>

        <v-flex
          color="primary"
          py-3
          text-xs-center
          xs12
        >
        <div>Developed with <a href="https://textlint.github.io/" class="white--text">textlint</a></div>
        <div>&copy;2018 — <a href="https://twitter.com/sutaba_mac" class="white--text font-weight-medium">{{ twitter.name }}</a></div>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      sidebar: false,
      twitter: {
        'name': '@sutaba_mac',
        'href': 'https://twitter.com/sutaba_mac'
      },
      links: [
        {'label': '利用規約', 'route': '/terms'},
      ],
    }
  },
  computed: {
    appTitle () {
      return this.$store.state.appTitle;
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated;
    },
    menuItems () {
      if (this.isAuthenticated) {
        return [
          { title: '文章チェック', path: '/', icon: 'spellcheck' },
          { title: '利用規約', path: '/terms', icon: 'description' },
        ];
      } else {
        return [
          { title: '文章チェック', path: '/', icon: 'spellcheck' },
          { title: '利用規約', path: '/terms', icon: 'description' },
          // { title: 'Sign Up', path: '/signup', icon: 'face' },
          // { title: 'Sign In', path: '/signin', icon: 'lock_open' },
        ];
      }
    }
  },
  methods: {
    userSignOut () {
      this.$store.dispatch('userSignOut');
    }
  },
  watch: {
    '$route': function (to, from) {
      if (to.path !== from.path) {
        window.scrollTo(0,0);
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue